import React from "react";

const PRIVACY_DOCUMENT_URL = "/legal/privacy.html";

export default function Privacy() {
  return <main className="min-h-screen bg-bone pt-16" data-testid="privacy-page"><iframe title="FYLLR Privacy Policy" src={PRIVACY_DOCUMENT_URL} className="min-h-[calc(100vh-4rem)] w-full border-0 bg-bone" data-testid="privacy-document-frame" /></main>;
}